import useFetchData from '@shared/hooks/useFetchData';
import { identificatorsService } from '@modules/additionalSettings/nomenclatures/services/identificators';
import { useState, useEffect } from 'react';

const useIdentificators = () => {
    const {
        data,
        loading,
        error,
        pageNumber,
        totalPages,
        totalElements,
        selectedData,
        sortBy,
        sortDir,
        pageSize,
        showDeleteConfirmation,
        searchQuery,
        searchType,
        setData,
        setLoading,
        setError,
        setpageNumber,
        setTotalPages,
        setTotalElements,
        setSelectedData,
        setSortBy,
        setSortDir,
        setPageSize,
        setShowDeleteConfirmation,
        setSearchQuery,
        setSearchType,
        fetchData,
        handleCheckboxChange,
        handleSort,
        handleSearchClick,
        handleError,
    } = useFetchData();

    // State for second table (nomstruct data)
    const [nomstructData, setNomstructData] = useState([]);
    const [nomstructLoading, setNomstructLoading] = useState(false);
    const [nomstructError, setNomstructError] = useState(null);

    // State for nomenclatures data
    const [nomenclaturesData, setNomenclaturesData] = useState([]);
    const [nomenclaturesLoading, setNomenclaturesLoading] = useState(false);
    const [nomenclaturesError, setNomenclaturesError] = useState(null);

    const fetchIdentificators = async (params = {}) => {
        return await fetchData(identificatorsService.getDeterms, params);
    };

    const handleSearchIdentificators = async (params = {}) => {
        return await handleSearchClick(identificatorsService.getDeterms, params);
    };

    const handleSortIdentificators = (column) => {
        handleSort(column, identificatorsService.getDeterms);
    };

    // New method to fetch nomstruct data when a determ is selected
    const fetchNomstruct = async (determId) => {
        if (!determId) {
            setNomstructData([]);
            return;
        }

        setNomstructLoading(true);
        setNomstructError(null);

        try {
            const data = await identificatorsService.getNomstruct(determId);
            setNomstructData(data);
        } catch (error) {
            console.error('Error fetching nomstruct:', error);
            setNomstructError(error);
            setNomstructData([]);
        } finally {
            setNomstructLoading(false);
        }
    };

    // New method to fetch nomenclatures data when a determ is selected
    const fetchNomenclatures = async (determId) => {
        if (!determId) {
            setNomenclaturesData([]);
            return;
        }

        setNomenclaturesLoading(true);
        setNomenclaturesError(null);

        try {
            const data = await identificatorsService.getNomenclatures(determId);
            setNomenclaturesData(data);
        } catch (error) {
            console.error('Error fetching nomenclatures:', error);
            setNomenclaturesError(error);
            setNomenclaturesData([]);
        } finally {
            setNomenclaturesLoading(false);
        }
    };

    return {
        data,
        loading,
        error,
        pageNumber,
        totalPages,
        totalElements,
        selectedData,
        sortBy,
        sortDir,
        pageSize,
        showDeleteConfirmation,
        searchQuery,
        searchType,
        setData,
        setLoading,
        setError,
        setpageNumber,
        setTotalPages,
        setTotalElements,
        setSelectedData,
        setSortBy,
        setSortDir,
        setPageSize,
        setShowDeleteConfirmation,
        setSearchQuery,
        setSearchType,
        fetchIdentificators,
        handleSearchIdentificators,
        handleSortIdentificators,
        handleCheckboxChange,
        handleError,
        // New properties for second table
        nomstructData,
        nomstructLoading,
        nomstructError,
        fetchNomstruct,
        // New properties for nomenclatures data
        nomenclaturesData,
        nomenclaturesLoading,
        nomenclaturesError,
        fetchNomenclatures,
    };
};

export default useIdentificators; 